import { createApp } from 'vue'
import App from './App.vue'

import router from './router'

import { createPinia } from 'pinia'
import { version } from '../package.json'

// import Chessboard from './js/henry-chessboard.js'
// import "@/css/henry-chessboardjs.css"

// https://pinia.vuejs.org/core-concepts/outside-component-usage.html#single-page-applications


import HoneybadgerVue from '@honeybadger-io/vue'
import { registerSW } from 'virtual:pwa-register'

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import '@/css/henry.css'

// for cm-chessboard
import './css/chessboard.css';
import './css/arrows.css';
import './css/markers.css';
import "./css/promotion-dialog.css"

/* Theme variables */
import './theme/variables.css';





const pinia = createPinia()
const app = createApp(App)

app.use(IonicVue)
app.use(router)
app.use(pinia)

registerSW({
  onRegistrationError(error) {
    console.warn('SW registration failed:', error)
  }
})

function isBot() {
  const ua = navigator.userAgent.toLowerCase()
  return /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebot|ia_archiver|crawler|spider|bot/.test(ua)
}

const honeybadgerConfig = {
  apiKey: 'hbp_Wko63RgGZzhwHwL2LbOKXl01ZUVhf01rXQyU',
  environment: 'production',
  revision : version,
    beforeNotify: (notice) => {
      // Use self instead of window so it safely resolves in Web/Service Workers
      const userAgent = typeof self !== 'undefined' && self.navigator ? self.navigator.userAgent : '';
      
      const ignoredRobots = [/Googlebot/i, /Bingbot/i, /Slurp/i, /DuckDuckBot/i, /Baiduspider/i];
      const isRobot = ignoredRobots.some(regex => regex.test(userAgent));

      if (isRobot) {
        return false; // Safely drops the Googlebot crash!
      }
      
      return true;
    }
}

if (import.meta.env.MODE === 'production') {
  console.log("**** this is production with HoneyBadger Error Trapping")
  app.use(HoneybadgerVue, honeybadgerConfig)
}
else {
  console.log("**** this is DEVELOPMENT")
}

router.isReady().then(() => {
  app.mount('#app');
});

// createApp(App).use(createPinia()).use(router).mount('#app')
